var elemental = require("../elem/elem.js");

export function multilevel(menu) {

    console.log(menu);
    
    var elems = document.querySelectorAll(menu);

    elems.forEach(function (elem, index) {

        elem.childNodes.forEach(function (child, index) {
            if(child.classList) {
                if(child.classList.contains('menu-item-has-children')) {
                    child.childNodes[0].appendChild(
                        elemental.elem('<span class="dropdown"></span>')
                    );
                }
            }
         });    
    });

    elems.forEach(function (elem, index) {

        elem.addEventListener('click', (elem) => {

            elem.stopPropagation();

            let dropdowns = document.querySelectorAll('.dropdown');

            if(dropdowns) {
                dropdowns.forEach(function (dropdown, index) {
                    dropdown.parentNode.classList.remove('active');
                });
            }

            if( elem.target.classList.contains('dropdown')
            ) {
                
                console.log(elem.target.parentNode.parentNode.classList.contains('active'));
                
                if(elem.target.parentNode.classList.contains('active')) {
                    
                    elem.target.parentNode.classList.remove('active');
                } else {
                    elem.target.parentNode.classList.add('active');
                }

               
            }

        });

    });

}